(() => {
  const media = window.matchMedia('(min-width: 769px)');
  function prepare() {
    document.querySelectorAll('[data-mc-footer-details]').forEach(item => {
      const hasResult = item.querySelector('[role="status"], .errors');
      item.open = media.matches || Boolean(hasResult);
    });
  }
  media.addEventListener('change', prepare);
  document.addEventListener('shopify:section:load', prepare);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare);
  else prepare();
})();